import script from "./VoterForm.vue?vue&type=script&setup=true&lang=js"
export * from "./VoterForm.vue?vue&type=script&setup=true&lang=js"

import "./VoterForm.vue?vue&type=style&index=0&id=e018e7e0&lang=css"

const __exports__ = script;

export default __exports__